



export function admin(){

     return [
        'providers',
        'admin',
    ]
   
}


export function adminApp(){

     return [
        'home',
        'goku',
        'providers'
    ]
   
}


export function staff(){

     return [
        'purchase',
        'sale',
        'inventory',
        'customer',
        'accounts',
    ]
   
}





/*

export function admin(){

     return [
        'home',
        'homestaff',
        'goku',
        'powers',
        'monitor',
        'users',
    ]
   
}


export function adminApp(){

     return [
        'home',
        'goku',
    ]
   
}


export function staff(){

     return [
        'homestaff',
        'goku',
        'powers',
        'monitor',
        'users',
    ]
   
}




*/